import { Button, ButtonLink } from "@sikt/sds-button";
import { Heading1, Heading2, Link, Paragraph } from "@sikt/sds-core";
import { DeleteIcon } from "@sikt/sds-icons";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { forgetVote, listMyVotes, type MyVote } from "../lib/myVotes";
import styles from "./HomePage.module.css";

function formatDate(iso: string): string | null {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat("nb-NO", { dateStyle: "medium" }).format(date);
}

export function HomePage() {
  const [mine, setMine] = useState<MyVote[]>(() => listMyVotes());

  const remove = (voteId: string) => {
    forgetVote(voteId);
    setMine(listMyVotes());
  };

  return (
    <>
      <div className={styles.hero}>
        <Heading1 size="xl">Stem</Heading1>
        <Paragraph size="l">
          Lag en avstemning på sekunder, del lenken, og se resultatene komme
          inn direkte.
        </Paragraph>
        <ButtonLink asChild variant="strong">
          <RouterLink to="/ny">Opprett avstemning</RouterLink>
        </ButtonLink>
      </div>

      {mine.length > 0 && (
        <section className={styles.mine} aria-labelledby="mine-avstemninger">
          <Heading2 id="mine-avstemninger" size="s">
            Dine avstemninger
          </Heading2>
          <Paragraph size="s" color="secondary">
            Listen lagres bare i denne nettleseren, slik at du finner tilbake
            til resultatlenkene dine.
          </Paragraph>
          <ul className={styles.list}>
            {mine.map((vote) => {
              const created = formatDate(vote.createdAt);
              return (
                <li key={vote.voteId} className={styles.item}>
                  <span className={styles.itemText}>
                    <Paragraph as="span" modifier="strong">
                      {vote.title}
                    </Paragraph>
                    {created && (
                      <Paragraph as="span" size="s" color="secondary">
                        Opprettet {created}
                      </Paragraph>
                    )}
                  </span>
                  <span className={styles.itemActions}>
                    <Link asChild>
                      <RouterLink to={`/v/${vote.voteId}`}>Stem</RouterLink>
                    </Link>
                    <Link asChild>
                      <RouterLink to={`/r/${vote.resultsId}`}>
                        Resultater
                      </RouterLink>
                    </Link>
                    <Button
                      type="button"
                      size="small"
                      variant="neutral-transparent"
                      icon={<DeleteIcon />}
                      iconVariant="only"
                      onClick={() => remove(vote.voteId)}
                    >
                      {`Fjern «${vote.title}» fra listen`}
                    </Button>
                  </span>
                </li>
              );
            })}
          </ul>
        </section>
      )}
    </>
  );
}
